__turbopack_context__.v({
  "className": "accent_f816de54-module__aAS-RG__className",
  "variable": "accent_f816de54-module__aAS-RG__variable",
});
